import { Injectable } from '@angular/core'
import { contract } from '@ftr/annotations-contracts/v2'
import { Region } from '@ftr/contracts/type/court'
import { AnnotationsApiClientFactoryBase } from './annotations-api-client.factory.base'
import { AnnotationsApiClientV2 } from './types'

/**
 * Create a client service for ftr-annotations v2 for a given region
 */
@Injectable({
  providedIn: 'root',
})
export class AnnotationsApiClientFactoryV2 extends AnnotationsApiClientFactoryBase {
  build(region: Region): AnnotationsApiClientV2 {
    return this.buildClient(region, contract, 'annotations-v2')
  }
}
